import React from 'react';

export const SendIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        width={props.width || 32}
        height={props.height || 33}
        {...props}
        viewBox="0 0 32 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M8 1H24C28.1421 1 31.5 4.35786 31.5 8.5V24.5C31.5 28.6421 28.1421 32 24 32H8C3.85786 32 0.5 28.6421 0.5 24.5V8.5C0.5 4.35786 3.85786 1 8 1Z" fill={props.fill || '#F5F5F5'} />
        <path d="M8 1H24C28.1421 1 31.5 4.35786 31.5 8.5V24.5C31.5 28.6421 28.1421 32 24 32H8C3.85786 32 0.5 28.6421 0.5 24.5V8.5C0.5 4.35786 3.85786 1 8 1Z" stroke="#B3B3B3" stroke-linecap="round" />
        <path d="M16 21.1666V11.8333M16 11.8333L11.3334 16.5M16 11.8333L20.6667 16.5" stroke='#ffffff' stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
);